import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import cn from 'clsx'
import type { TTagProps } from './Tag.types'
import styles from './Tag.module.css'

const tag = cva(styles.tag, {
    variants: {
        variant: {
            default: styles['variant-default'],
            accent: styles['variant-accent'],
            format: styles['variant-format'],
        },
        size: {
            default: styles['size-default'],
            large: styles['size-large'],
            format: styles['size-format'],
        },
    },
    defaultVariants: { variant: 'default', size: 'default' },
})

export const Tag = forwardRef<HTMLSpanElement, TTagProps>(
    ({ className, variant = 'default', size = 'default', children, Icon, ...props }, ref) => (
        <span ref={ref} className={cn(tag({ variant, size }), className)} {...props}>
            {Icon ? <Icon className={styles.icon} /> : null}
            <span className={styles.label}>{children}</span>
        </span>
    ),
)
